import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchBalance } from "../features/transaction/transactionSlice";

const Balance = () => {
  const { totalBalance } = useSelector((state) => state.transaction);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchBalance());
  }, [dispatch]);
  return (
    <div className='top_card'>
      <p>Your Current Balance</p>
      <h3>
        <span>{`৳ `}</span>

        <span>{totalBalance.toLocaleString("en-us")}</span>
      </h3>
    </div>
  );
};

export default Balance;
